import { Box, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ProjectsGrid } from '../../projects/ProjectsGrid';

/**
 * Projects the employee is a team member of. Own profile uses the
 * "projects/own" endpoint, other employees are filtered by userId.
 */
export const EmployeeProjects = ({ employeeInfo, own }) => {
  const { t } = useTranslation();
  const [projectStatus, setProjectStatus] = useState('active');

  if (!employeeInfo) return null;

  // "projects/own" (used for the own active projects) ignores the user filter,
  // every other listing is restricted to projects the employee is a member of
  const filterString = `userId[eq]=${employeeInfo.id}`;

  return (
    <Box className="flex flex-col gap-2 h-full w-full">
      <ToggleButtonGroup
        size="small"
        exclusive
        value={projectStatus}
        onChange={(_, value) => value && setProjectStatus(value)}
      >
        <ToggleButton value="active">{t('Active')}</ToggleButton>
        <ToggleButton value="archive">{t('Archived')}</ToggleButton>
      </ToggleButtonGroup>
      <ProjectsGrid
        projectStatus={own && projectStatus === 'active' ? 'own' : projectStatus}
        filterString={filterString}
        viewMode="list"
        hideCreate
      />
    </Box>
  );
};

export default EmployeeProjects;
